<form [formGroup]="signInForm" (yatSubmit)="submitForm($event)">
  <div class="form-row">
    <div class="col-12">
      <yat-form-group labelFor="email" [label]="'accountUi.signInForm.emailAddress.label' | transloco" class="skeleton-item">
        <input
          type="email"
          id="email"
          [placeholder]="'accountUi.signInForm.emailAddress.placeholder' | transloco"
          formControlName="email"
          maxlength="254"
          (input)="compareEmailWithLastCheck()"
          yatAutoFocus
          yatInput />
        <div class="invalid-feedback" [ngSwitch]="signInForm.controls.email.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">{{ 'accountUi.signInForm.emailAddress.validators.required' | transloco }}</span>
          <span *ngSwitchCase="'email'">{{ 'accountUi.signInForm.emailAddress.validators.email' | transloco }}</span>
        </div>
      </yat-form-group>
    </div>
  </div>
  <div class="form-row" *ngIf="isSignInWithPassword$ | async">
    <div class="col-12">
      <yat-form-group labelFor="password" [label]="'accountUi.signInForm.password.label' | transloco" class="skeleton-item">
        <input type="password" id="password" formControlName="password" maxlength="64" yatInput yatAutoFocus />
        <div class="invalid-feedback" [ngSwitch]="signInForm.controls.password.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">{{ 'accountUi.signInForm.password.validators.required' | transloco }}</span>
          <span *ngSwitchCase="'blacklisted'">{{ 'accountUi.signInForm.password.validators.blacklisted' | transloco }}</span>
        </div>
        <a
          yat-link
          [routerLink]="null"
          class="link link-secondary lbl-forgot-password skeleton-item"
          (click)="forgotPassword()"
          tabindex="0"
          [matomoClickCategory]="MATOMO_EVENT_CATEGORY_ACCOUNT"
          matomoClickAction="Select_ForgotPasswordLink"
          >{{ 'accountUi.signInForm.forgotPassword' | transloco }}</a
        >
      </yat-form-group>
    </div>
  </div>
  <div class="form-row">
    <div class="col-12">
      <button
        yat-button
        type="submit"
        class="btn btn-large primary btn w-100"
        [yatAutoSpinner]="spinnerActionFilter"
        [disabled]="signInForm.controls.email.value.length === 0"
        [matomoClickCategory]="MATOMO_EVENT_CATEGORY_ACCOUNT"
        matomoClickAction="Select_SignIn"
        [matomoClickName]="(isSignInWithPassword$ | async) ? 'SignInWithPassword' : 'ContineWithEmail'">
        <span>{{ (isSignInWithPassword$ | async) ? ('accountUi.signInForm.signIn' | transloco) : ('continue' | commonWording | async) }}</span>
      </button>
    </div>
  </div>
</form>
